import { Link } from "react-router-dom";
import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, spacing, breakpoints } = globalStyles;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DesktopWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${colors.primary.offWhite};
  padding: ${spacing.space24} ${spacing.space24};

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div<{ $isMenuOpen: boolean }>`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
  background-color: ${({ $isMenuOpen }) => ($isMenuOpen ? colors.primary.green : colors.primary.offWhite)};
  padding: ${spacing.space8} ${spacing.space16};
  position: relative;
  z-index: 100;

  @media (max-width: ${breakpoints.m}) {
    display: flex;
  }
`;

export const MenuButtonContainer = styled.div`
  display: none;
  position: relative;
  z-index: 101;

  @media (max-width: ${breakpoints.m}) {
    display: block;
  }
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  color: ${colors.typography.black};
  margin-right: ${spacing.space32};
  padding: ${spacing.space8} ${spacing.space16};
  font-size: 1.6rem;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    text-decoration: none;
    background-color: ${colors.primary.green};
    border-radius: 5px;
    color: ${colors.primary.offWhite};
  }

  @media (max-width: ${breakpoints.s}) {
    display: none;
  }
`;

export const NavLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const NavbarLogo = styled.img`
  height: 110px;
  width: 155px;

  @media (max-width: ${breakpoints.m}) {
    height: 72px;
    width: 100px;
  }
`;

export const NavbarLogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 101;
`;
